import { Site, formatNumber } from '@debbie/common/dist/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { styled } from 'styled-components';
import logoDark from '../assets/images/logodark.svg';
import { ENV, IS_PROD } from '../config.js';
import THEME from '../theme.js';
import Alert from './Alert.js';
import ChevronLeft from './Icons/ChevronLeft.js';
import Hamburger from './Icons/Hamburger.js';
const LeftNav = (props) => {
    const leftNavOpen = useSelector((s) => s.leftNavOpen);
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const tenant = useTenant();
    const { links, logo } = props;
    return (React.createElement(LeftNavStyled, { open: leftNavOpen },
        React.createElement("header", null,
            React.createElement(Hamburger, { className: "hamburger", open: !leftNavOpen, onClick: () => {
                    c.local.toggleRightNav();
                } }),
            React.createElement(ChevronLeft, { className: "hamurger-arrow" }),
            React.createElement(NavLink, { className: "logo", exact: true, to: "/" }, logo ? React.createElement("img", { src: logo, alt: "Logo" }) : null)),
        site === Site.Caseworker && tenant?.settings.disableWorkflows && (React.createElement(Alert, { message: lang.workflows.settings.workflowsDisabled, size: "small", style: {
                margin: `${THEME.GRID_SPACING}px ${THEME.GRID_SPACING}px 0 ${THEME.GRID_SPACING}px`,
            } })),
        React.createElement("div", { className: "navbar-content" },
            React.createElement("ul", null, links.map(({ path, text, exact = true, links, count, external }, i) => (React.createElement("li", { key: i, className: links && links.some((l) => l.path === path)
                    ? 'with-duplicate'
                    : '' },
                React.createElement(NavLink, { exact: exact, to: path || window.location.pathname, onClick: (e) => {
                        if (external) {
                            e.preventDefault();
                            window.open(path);
                        }
                    } },
                    text,
                    ' ',
                    count && count > 0 && (React.createElement(Badge, { style: {
                            fontSize: '0.5em',
                        } }, formatNumber(count * 100).slice(0, -3)))),
                links && links.length > 0 && (React.createElement("ul", null, links.map(({ path, text, exact = true, count, icon, external, beta, }, i) => (React.createElement("li", { key: i }, React.createElement(NavLink, { exact: exact, to: path, onClick: (e) => {
                        if (external) {
                            e.preventDefault();
                            window.open(path);
                        }
                    } },
                    icon && React.createElement("div", { className: "link-icon" }, icon),
                    text,
                    " ",
                    beta ? React.createElement(Badge, null, "beta") : null,
                    count && count > 0 ? (React.createElement(Badge, null, formatNumber(count * 100).slice(0, -3))) : null)))))))))),
            props.children,
            React.createElement("div", { className: "env" },
                React.createElement("a", { href: "https://debbiecollect.com", target: "_blank", rel: "noreferrer" },
                    React.createElement("img", { src: logoDark, style: { height: '20px', margin: '-5px 0px' } })),
                React.createElement("span", { style: { marginLeft: '.8em' } }, !IS_PROD && ENV)))));
};
export default LeftNav;
const LeftNavStyled = styled.div `
  width: ${() => () => THEME.NAV_LEFT_WIDTH}px;
  height: 100vh;
  position: fixed;
  color: ${() => THEME.COLOR_PRIMARY};
  top: 0px;
  left: 0px;
  transition: all 0.3s;
  transform: ${(props) => props.open ? 'translate3d(0, 0, 0)' : 'translate3d(-50px,0,0)'};

  @media ${() => THEME.MEDIA_QUERY_MOBILE} {
    border-right: 1px solid rgba(0, 0, 0, 0.4);
    transform: ${(props) => props.open ? 'translate3d(0, 0, 0)' : 'translate3d(-50px,0,0)'};
  }

  header {
    transition: background-color 0.3s;
    height: ${() => THEME.NAV_TOP_HEIGHT}px;
    overflow: hidden;

    .logo {
      img {
        margin: 14px 25px;
        height: 33px;
      }
    }

    .hamburger {
      float: right;
      padding-left: 0px;
    }

    .hamurger-arrow {
      float: right;
      height: ${() => THEME.NAV_TOP_HEIGHT}px;
    }
  }

  .env {
    position: fixed;
    bottom: 15px;
    left: 20px;
    margin: 0;
    font-size: 0.7em;
  }

  .navbar-content {
    height: calc(100vh - 105px);
    padding-bottom: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }

    & > ul {
      margin-top: 15px;
      padding: 0;

      div.link-icon {
        margin: 0 17px 0 0;
        display: inline-block;
        vertical-align: middle;

        svg {
          height: 20px;
          width: 20px;
        }
      }

      & > li {
        list-style-type: none;
        position: relative;
        &.with-duplicate > a {
          &:focus::before,
          &::before,
          &.active::before {
            display: none !important;
          }
        }

        a {
          padding: 0.7em 25px;
          display: block;
          color: ${() => THEME.COLOR_GREY};
          font-weight: 900;
          text-decoration: none;
          text-transform: uppercase;
          font-size: 0.8em;
          transition: all 200ms ease;

          * {
            color: inherit;
          }

          &.active,
          &:hover {
            font-weight: 900;
            text-decoration: none !important;
          }
        }
        &:focus {
          text-decoration: none !important;
        }

        & > ul {
          margin-left: 25px;
          margin-bottom: 15px;
          padding: 0;

          & > li {
            list-style-type: none;
            position: relative;
            font-size: 0.6em;

            a {
              font-weight: normal;
              padding: 6px 15px 6px 0px;
              color: ${() => THEME.COLOR_PRIMARY};
              font-size: 1.5em;
              text-transform: initial;

              &:focus::before {
                top: 7px;
              }

              &.active {
                &::before {
                  top: 7px;
                }
              }
            }
          }
        }
      }
    }
  }
`;
const Badge = styled.span `
  background-color: ${() => THEME.COLOR_SECONDARY};
  padding: 0.3em 0.5em;
  color: ${() => THEME.COLOR_PRIMARY} !important;
  border-radius: 1em;
  font-weight: bold;
  font-size: 0.7em;
  vertical-align: middle;
`;
//# sourceMappingURL=LeftNav.js.map